export default doc => {
  if (doc.type === 'blog_post') {
    return doc.uid ? `/news/${doc.uid}` : `/news/${doc.id}`;
  }

  return '/';
};
